import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerReachConfig: KpiType<typeof MediaViewerKpiLoader> = {
    name: 'kpi.tiktok.reach',
    id: 'reach',
    icon: {
        name: 'reach',
        style: colors.yellow
    },
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_50,
    orientation: ORIENTATION_VERTICAL,
    mergedData: true,
    type: 'kpi',
    loader: MediaViewerKpiLoader
};
